import { Controller } from '@hotwired/stimulus';
import GraficoOcupacion from '../transporte/grafico_ocupacion';

export default class extends Controller {
  connect() {
    this.#cargarGraficos();
    const check = this.element.querySelector('#ver-finalizados');
    check.addEventListener('change', () => {
      this.#mostrarFinalizados(check.checked);
    });
    this.#mostrarFinalizados(false);
  }

  #mostrarFinalizados(mostrar) {
    this.element.querySelectorAll('.finalizado').forEach((row) => {
      if (mostrar) {
        row.classList.remove('hide');
      } else {
        row.classList.add('hide');
      }
    });
  }

  #cargarGraficos() {
    this.element.querySelectorAll('canvas.chart-ocupacion').forEach((canvas) => {
      const grafico = new GraficoOcupacion(canvas);
      grafico.cargarGrafico();
    });
  }
}
